import React from 'react';
import {
  translate as t,
  GET_LIST,
  // UPDATE
} from 'admin-on-rest';
import {
  TextField,
  DatePicker,
  Dialog,
  FlatButton,
  ListItem,
  MenuItem,
  List,
  RaisedButton,
  SelectField,
  TimePicker,
} from 'material-ui';
import moment from 'moment';
import plz from 'await-plz';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
// import InviteIcon from 'material-ui/svg-icons/communication/mail-outline';
import EditIcon from 'material-ui/svg-icons/image/edit';
import EventIcon from 'material-ui/svg-icons/action/event';
import AddIcon from 'material-ui/svg-icons/content/add';
import GroupIcon from 'material-ui/svg-icons/social/group';
import PersonIcon from 'material-ui/svg-icons/social/person';
import CommentIcon from 'material-ui/svg-icons/communication/comment';

import NewsPublisher from '../AcademyViewer/NewsPublisher';

// import UserDropDown from '../AcademyViewer/UserDropDown';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const styles = {
  textField: {
    display: 'block',
  },
  card: {
    padding: '10px',
  },
  toggle: {
    maxWidth: '50%',
  },
  deleteIcon: {
    fill: 'rgb(255, 193, 7)',
  },
  dialogContent: {
    width: '95%',
    maxWidth: '996px',
  },
  confirmActionsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    padding: '10px',
  },
  richTextDiv: {
    marginTop: '20px',
  },
  richTextLabel: {
    marginBottom: '10px',
    color: 'rgba(0, 0, 0, 0.3)',
  },
};

class CourseMomentsInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: true,
      open: false,
      courseMoments: Object.keys(this.props.record).length > 0 ? this.props.record.courseMoment : [],
      confirmMoment: '',
      loading: true,
    };
  }

  componentDidMount = async () => {
    const [err, res] = await plz(restClient(GET_LIST, 'venues', { sort: {}, pagination: {}, filter: {} }));
    if (err) console.log('venue fetch E', err);
    this.setState({ venues: res.data, loading: false });
  }

  getVenueTitle = (venueName) => {
    const { venues } = this.state;
    const { locale } = this.props;
    const venueObj = venues.find((venue) => venue.name === venueName);
    return venueObj ? (
      venueObj.ModernTitles[locale] ? (
        venueObj.ModernTitles[locale]
      ) : (
        venueObj.ModernTitles.en
      )
    ) : ('');
  }

  // it's null if it doesn't already exist. Meaning if you edit an existing item you use createdAt to identify it
  openCourseMoment = (createdAt = null) => {
    if (createdAt) {
      const courseMoment = this.state.courseMoments.find((obj) => obj.createdAt === createdAt);
      this.setState({
        ...courseMoment,
        start: moment(courseMoment.start)._d,
        end: moment(courseMoment.end)._d,
        lastRegistrationDate: moment(courseMoment.lastRegistrationDate)._d,
        startTime: moment(courseMoment.startTime)._d,
        open: true,
        edit: true,
      }); // force the dates to be JS date objects for the date picker to display them properly
    } else {
      this.setState({ createdAt: new Date().valueOf(), teacher: '', address: '', maxAttendees: '', start: '', end: '', lastRegistrationDate: '', description: '', edit: false, city: '', startTime: '' });
    }
    this.handleOpen();
  }

  openPassAttendeeModal = (courseMoment) => {
    this.handleOpenPassAttendee();
    this.setState({ attendeesList: courseMoment });
  }

  handlePassAttendeesChange = (e, i, value) => this.setState({ attendeesValues: value });

  handlePassAttendee = () => {
    // const { attendeesValues } = this.state;
    // restClient(UPDATE, 'students', { id: attendeesValues })
    //   .then((d) => console.log('we updated yoru students', d))
    //   .catch((e) => console.log('my passAttendees E', e));
    this.handleClosePassAttendee();
  };

  // dialog for courses
  handleOpen = () => this.setState({ open: true });
  handleClose = () => this.setState({ open: false });

  // dialog for delete confirmation
  handleOpenConfirm = (index) => this.setState({ openConfirmDelete: true, confirmMoment: this.state.courseMoments[index], confirmIndex: index })
  handleCloseConfirm = () => this.setState({ openConfirmDelete: false })

  // dialog for delete confirmation for deleting registered parties
  handleOpenConfirmParty = (cMomentIndex, partyIndex) => this.setState({
    openConfirmDeleteParty: true,
    confirmParty: this.state.courseMoments[cMomentIndex].attendees[partyIndex],
    confirmIndex: { courseMomentIndex: cMomentIndex, partyIndex },
  })

  handleCloseConfirmParty = () => this.setState({ openConfirmDeleteParty: false })

  handleOpenPassAttendee = () => this.setState({ openPassAttendee: true });
  handleClosePassAttendee = () => this.setState({ openPassAttendee: false, attendeesValues: [] });

  // handle fields
  handleTextChange = (e, val) => this.setState({ [e.target.name]: val });
  handleToggle = (e, val) => this.setState({ toggled: val });

  handleSaveMoment = () => {
    const { createdAt, teacher, address, attendees, maxAttendees, start, end, lastRegistrationDate, description, startTime, city, endTime } = this.state;
    if (!start || !teacher || !address || !maxAttendees || !end || !lastRegistrationDate || !startTime || !city) {
      this.setState({ error: this.props.translate('academy.blankFields') });
      return;
    }
    const momentData = { createdAt, teacher, address, attendees, maxAttendees, start, end, lastRegistrationDate, description, startTime, city, endTime };
    const tempState = this.state.courseMoments.slice();
    const index = tempState.findIndex((obj) => obj.createdAt === createdAt);
    if (index > -1) {
      tempState[index] = momentData;
    } else {
      tempState.push(momentData);
    }
    this.setState({ courseMoments: tempState });
    this.props.input.onChange(tempState);
    this.handleClose();
  }

  handleDeleteMoment = (index) => {
    const fields = [...this.state.courseMoments];
    const filteredFields = fields.filter((item, i) => i !== index);
    this.setState({ courseMoments: filteredFields, openConfirmDelete: false });
    this.props.input.onChange(filteredFields);
  }

  handleDeleteParty = (indices) => {
    const fields = [...this.state.courseMoments];
    const filteredFields = fields.map((item, i) => {
      if (i === indices.courseMomentIndex) {
        item.attendees.splice(indices.partyIndex, 1);
      }
      return item;
    });
    this.setState({ courseMoments: filteredFields, openConfirmDeleteParty: false });
    this.props.input.onChange(filteredFields);
  }

  handleStartDateChange = (e, date) => this.setState({ start: date });
  handleStartTimeChange = (e, time) => this.setState({ startTime: time });
  handleEndTimeChange = (e, time) => this.setState({ endTime: time });

  handleEndDateChange = (e, date) => this.setState({ end: date });
  handleLastRegistrationDate = (e, date) => this.setState({ lastRegistrationDate: date });
  handleTinyMCChange = (e) => this.setState({ description: e.target.getContent() });

  render() {
    const { courseMoments, attendeesValues } = this.state;
    const { translate } = this.props;
    console.log('props and state', this.props, this.state);
    const actions = [
      <FlatButton onClick={this.handleClose}>{translate('cancel')}</FlatButton>,
      <FlatButton onClick={this.handleSaveMoment} primary>{translate('add')}</FlatButton>,
    ];
    const confirmActions = [
      <RaisedButton onClick={this.handleCloseConfirm} label={translate('cancel')} />,
      <RaisedButton primary onClick={() => this.handleDeleteMoment(this.state.confirmIndex)} label={translate('remove')} />,
    ];
    const passAttendeeActions = [
      <RaisedButton onClick={this.handleClosePassAttendee} label={translate('cancel')} />,
      <RaisedButton primary onClick={() => this.handlePassAttendee()} label={translate('pass')} />,
    ];

    const confirmActionsParty = [
      <RaisedButton onClick={this.handleCloseConfirmParty} label={translate('cancel')} />,
      <RaisedButton primary onClick={() => this.handleDeleteParty(this.state.confirmIndex)} label={translate('remove')} />,
    ];

    return (
      <div>
        {this.state.loading ? <div /> : (
          <div>
            <FlatButton primary icon={<AddIcon />} onClick={() => this.openCourseMoment(null)} label={translate('create.item', { item: translate('academy.courseMoment') })} />
            {
              courseMoments && courseMoments.sort((a, b) => a.start.valueOf() - b.start.valueOf()).map((cMoment, i) => // sort dates in order
                (
                  <List>
                    <ListItem
                      value={cMoment._id}
                      innerDivStyle={{ display: 'flex', alignItems: 'center' }}
                      primaryText={moment(cMoment.start).format('YYYY MMM DD')}
                      primaryTogglesNestedList
                      leftIcon={<EventIcon />}
                      nestedItems={[
                        <ListItem
                          leftIcon={<EditIcon />}
                          onClick={() => this.openCourseMoment(cMoment.createdAt)}
                          primaryText={translate('edit.item', { item: translate('academy.courseMoment') })}
                        />,
                        // <ListItem
                        //   leftIcon={<InviteIcon />}
                        //   primaryText={translate('academy.invite')}
                        // />,
                        // <ListItem
                        //   leftIcon={<InviteIcon />}
                        //   primaryText="Godkänn deltagare"
                        //   onClick={() => this.openPassAttendeeModal(cMoment.attendeesList)}
                        // />,
                        <ListItem
                          primaryTogglesNestedList
                          leftIcon={<GroupIcon />}
                          primaryText={cMoment.attendeesList ? `${translate('academy.attendees')} ${cMoment.attendeesList.length}` : translate('academy.attendees')}
                          nestedItems={cMoment.attendees && cMoment.attendees.map((attendeeParty, j) => (
                            <ListItem
                              leftIcon={<img src="https://s3-eu-west-1.amazonaws.com/pinchos-statics/icons/svg/tent.svg" alt="venue icon" />}
                              primaryTogglesNestedList
                              key={`${cMoment._id}attendee`}
                              primaryText={`${this.getVenueTitle(attendeeParty.venue)} - ${attendeeParty.venueAttendees ? attendeeParty.venueAttendees.length : ''}`}
                              secondaryText={attendeeParty.comments ? (
                                `${attendeeParty.comments.length > 30 ? (
                                  `${attendeeParty.comments.substring(0, 30)}...`
                                ) : (
                                  attendeeParty.comments
                                )}`
                              ) : ''}
                              nestedItems={attendeeParty.comments ? [<ListItem leftIcon={<CommentIcon />} disabled primaryText={attendeeParty.comments} />]
                                .concat(attendeeParty && attendeeParty.venueAttendees.map((attendee) => (
                                  <ListItem
                                    leftIcon={<PersonIcon />}
                                    key={cMoment._id + attendee.name}
                                    disabled
                                    primaryText={attendee.name}
                                  />
                                )))
                                .concat(
                                  <ListItem
                                    onClick={() => this.handleOpenConfirmParty(i, j)}
                                    leftIcon={<DeleteIcon style={styles.deleteIcon} />}
                                    key={`${cMoment._id}delete`}
                                    primaryText={translate('academy.deleteAttendeeParty')}
                                  />
                                ) : (
                                attendeeParty && attendeeParty.venueAttendees.map((attendee) => (
                                  <ListItem
                                    leftIcon={<PersonIcon />}
                                    key={cMoment._id + attendee.name}
                                    disabled
                                    primaryText={attendee.name}
                                  />
                                ))
                                  .concat(
                                    <ListItem
                                      onClick={() => this.handleOpenConfirmParty(i, j)}
                                      leftIcon={<DeleteIcon style={styles.deleteIcon} />}
                                      key={`${cMoment._id}delete`}
                                      primaryText={translate('academy.deleteAttendeeParty')}
                                    />
                                  )
                              )}
                            />
                          ))}
                        />,
                        <ListItem
                          onClick={() => this.handleOpenConfirm(i)}
                          leftIcon={<DeleteIcon style={styles.deleteIcon} />}
                          primaryText={translate('academy.removeCourseMoment')}
                        />,
                      ]}
                    />
                  </List>
                ))
            }

            <Dialog
              title={translate('academy.courseMoment')}
              actions={actions}
              open={this.state.open}
              onRequestClose={this.handleClose}
              contentStyle={styles.dialogContent}
              autoScrollBodyContent
            >
              <TextField
                onChange={this.handleTextChange}
                floatingLabelText={translate('academy.teacher')}
                value={this.state.teacher}
                name="teacher"
                style={styles.textField}
                fullWidth
              />
              <TextField
                onChange={this.handleTextChange}
                floatingLabelText={translate('academy.address')}
                value={this.state.address}
                name="address"
                style={styles.textField}
                fullWidth
              />
              <TextField
                onChange={this.handleTextChange}
                floatingLabelText={translate('academy.city')}
                value={this.state.city}
                name="city"
                style={styles.textField}
                fullWidth
              />
              <TextField
                onChange={this.handleTextChange}
                floatingLabelText={translate('academy.maxAttendees')}
                value={this.state.maxAttendees}
                type="number"
                name="maxAttendees"
                style={styles.textField}
              />

              <DatePicker floatingLabelText={translate('academy.startDate')} value={this.state.start} onChange={this.handleStartDateChange} />
              <DatePicker floatingLabelText={translate('academy.endDate')} value={this.state.end} onChange={this.handleEndDateChange} />
              <TimePicker floatingLabelText={translate('academy.startTime')} format="24hr" value={this.state.startTime} onChange={this.handleStartTimeChange} />
              <TimePicker floatingLabelText={translate('academy.endTime')} format="24hr" value={this.state.endTime} onChange={this.handleEndTimeChange} />


              <DatePicker floatingLabelText={translate('academy.lastRegistrationDate')} value={this.state.lastRegistrationDate} onChange={this.handleLastRegistrationDate} />

              {
                this.state.edit && !this.state.edit && <NewsPublisher />
              }

              <p>{this.state.error && this.state.error}</p>
            </Dialog>

            <Dialog
              actions={confirmActions}
              open={this.state.openConfirmDelete}
              actionsContainerStyle={styles.confirmActionsContainer}
            >
              <p>{translate('academy.confirmDeleteCourseMoment')}</p> {moment(this.state.confirmMoment.start).format('YYYY MMM DD')}
            </Dialog>

            <Dialog
              actions={confirmActionsParty}
              open={this.state.openConfirmDeleteParty}
              actionsContainerStyle={styles.confirmActionsContainer}
            >
              {translate('academy.confirmDeleteParty')}
              <p>
                {this.state.confirmParty
                  ? <p> {translate('academy.venue')}: {this.state.confirmParty.venue} </p>
                  : ''} {
                  this.state.confirmParty
                    ? (
                      <p> {translate('academy.attendees')}: {this.state.confirmParty.venueAttendees.map((attendee) => attendee.name).join(', ')}</p>
                    ) : (
                      ''
                    )}
              </p>
            </Dialog>

            <Dialog
              actions={passAttendeeActions}
              open={this.state.openPassAttendee}
              actionsContainerStyle={styles.confirmActionsContainer}
            >
              <SelectField
                floatingLabelText={translate('academy.attendees')}
                value={this.state.attendeesValues}
                onChange={this.handlePassAttendeesChange}
                multiple
                fullWidth
              >
                {
                  this.state.attendeesList && this.state.attendeesList.map((attendee) => (
                    <MenuItem
                      value={attendee.phoneNumber}
                      primaryText={attendee.name}
                      checked={attendeesValues && attendeesValues.indexOf(attendee.phoneNumber) > -1}
                    />
                  ))
                }
              </SelectField>
            </Dialog>
          </div>
        )}
      </div>
    );
  }
}

CourseMomentsInput.defaultProps = {
  addField: true,
};

export default t(CourseMomentsInput);
